var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaignGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_3673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 12.55 18.45 13 19 13H21C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11H19C18.45 11 18 11.45 18 12Z",
    fill: "#C1CACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.59 16.82C16.26 17.26 16.35 17.87 16.79 18.19C17.32 18.58 17.88 19 18.41 19.4C18.85 19.73 19.47 19.64 19.79 19.2C19.79 19.19 19.8 19.19 19.8 19.18C20.13 18.74 20.04 18.12 19.6 17.8C19.07 17.4 18.51 16.98 17.99 16.59C17.55 16.26 16.93 16.36 16.6 16.8C16.6 16.81 16.59 16.82 16.59 16.82Z",
    fill: "#C1CACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8099 4.81001C19.8099 4.80001 19.7999 4.80001 19.7999 4.79001C19.4699 4.35001 18.8499 4.26001 18.4199 4.59001C17.8899 4.99001 17.3199 5.41001 16.7999 5.81001C16.3599 6.14001 16.2799 6.76001 16.6099 7.19001C16.6099 7.20001 16.6199 7.20001 16.6199 7.21001C16.9499 7.65001 17.5599 7.74001 17.9999 7.41001C18.5299 7.02001 19.0899 6.59001 19.6199 6.19001C20.0499 5.87001 20.1299 5.25001 19.8099 4.81001Z",
    fill: "#C1CACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9H4C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18V15H8L13 18V6L8 9Z",
    fill: "#C1CACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 10.67 14.92 9.46999 14 8.64999V15.34C14.92 14.53 15.5 13.33 15.5 12Z",
    fill: "#C1CACE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_3673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignGray);
export default __webpack_public_path__ + "static/media/campaign_gray.6cbecc9483185b5674756c31fbd806f0.svg";
export { ForwardRef as ReactComponent };